import type {QueryParams} from '@jetbrains/teamcity-ui/dist/utils'

import type {AppThunk} from '../../../../../actions/types'
import type {LoadedEndpoints} from '../../../../../routes/loadEndpoint'
import type {BuildId} from '../../../../../types'
import {isPipelineOverviewEnabled} from '../../../../../utils/featureToggles'

import {preloadDetails} from './Details/Details.preload'

export const preloadPipelineTab =
  (runId: BuildId, queryParams: QueryParams): AppThunk<LoadedEndpoints> =>
  dispatch => {
    const {sidebar, detailsFullscreen, job} = queryParams
    const shouldPreloadDetails =
      (isPipelineOverviewEnabled ? sidebar !== 'false' : job != null) ||
      detailsFullscreen === 'true'
    const loadedEndpoints: LoadedEndpoints = []
    if (shouldPreloadDetails) {
      loadedEndpoints.push(...dispatch(preloadDetails(runId, queryParams)))
    }
    return loadedEndpoints
  }
